export default __webpack_public_path__ + "static/logo-home-1f5cd26c7d3fa78cbc0c2a8ac9db3100.svg";